import React, { useState } from "react";
import { Box, Typography, IconButton } from "@material-ui/core";
import * as Icons from "@material-ui/icons";

import { PreparationNeededModal } from "./preparationNeededModal";

export function PreparationFilter({
  changePreparationLevel,
  preparationLevel,
}) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Box>
      <Box display="flex" alignItems="center" textAlign="center">
        <Typography variant="h5">Preparation needed</Typography>
        <Box>
          <IconButton
            aria-label="info"
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <Icons.InfoRounded />
          </IconButton>
          <PreparationNeededModal
            open={modalOpen}
            onClose={() => {
              setModalOpen(false);
            }}
          />
        </Box>
      </Box>
      <Box display="flex" justifyContent="center">
        <IconButton
          onClick={() => {
            changePreparationLevel(1);
          }}
        >
          <Icons.LooksOne
            style={
              preparationLevel.includes(1)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
        <IconButton
          onClick={() => {
            changePreparationLevel(2);
          }}
        >
          <Icons.LooksTwo
            style={
              preparationLevel.includes(2)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
        <IconButton
          onClick={() => {
            changePreparationLevel(3);
          }}
        >
          <Icons.Looks3
            style={
              preparationLevel.includes(3)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
        <IconButton
          onClick={() => {
            changePreparationLevel(4);
          }}
        >
          <Icons.Looks4
            style={
              preparationLevel.includes(4)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
        <IconButton
          onClick={() => {
            changePreparationLevel(5);
          }}
        >
          <Icons.Looks5
            style={
              preparationLevel.includes(5)
                ? { color: "#01a9f4" }
                : { color: "#918d8d" }
            }
            fontSize="large"
          />
        </IconButton>
      </Box>
    </Box>
  );
}
